// extracted by mini-css-extract-plugin
module.exports = {"sectionSales":"sectionSales___4is6y"};